/*import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight, MapPin, Quote } from 'lucide-react';

const TravelerStories = () => {
  const scrollRef = useRef(null);

  // --- MOCK STORIES DATA ---
  const stories = [
    {
      id: 1,
      name: "Ananya Sharma",
      location: "Spiti Valley, Himachal",
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80",
      image: "https://tripstorz.com/_astro/key-monastery-in-spiti-valley-during-winter.CLBQd5yK_Z2dSSsR.jpg",
      title: "Finding Silence in the Mountains",
      snippet: "The silence in Spiti isn't empty; it's full of answers. Living with the locals in a mud house changed how I view luxury..."
    },
    {
      id: 2,
      name: "Rahul Mehta",
      location: "Gokarna, Karnataka",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80",
      image: "https://s7ap1.scene7.com/is/image/incredibleindia/1-om-beach-gokarna-karnataka-city-hero?qlt=82&ts=1726720866389",
      title: "Beyond the Beaches",
      snippet: "Gokarna is more than just beaches. I hiked the cliff trails at sunrise and discovered a hidden temple that isn't on any map..."
    },
    {
      id: 3,
      name: "Priya & Amit",
      location: "Mawlynnong, Meghalaya",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80",
      image: "https://www.esikkimtourism.in/wp-content/uploads/2018/07/Meghalaya-Mawlynnong.jpg",
      title: "Walking on Living Roots",
      snippet: "The living root bridges are nature's engineering marvel. We stayed in a homestay where the host cooked us a bamboo feast..."
    },
    {
      id: 4,
      name: "David Mathew",
      location: "Varanasi, UP",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80",
      image: "https://www.indianpanorama.in/assets/images/tourpackages/banner/holy-varanasi.webp",
      title: "Colors of the Ghats",
      snippet: "Varanasi is an assault on the senses in the best way possible. The evening Aarti ceremony was a spiritual experience I'll never forget..."
    }
  ];

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { current } = scrollRef;
      const scrollAmount = 350; // Card width + gap
      if (direction === 'left') {
        current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  return (
    <section style={{ padding: '80px 0', backgroundColor: '#f9fafb' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* HEADER *}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end', marginBottom: '40px' }}>
          <div>
            <h2 style={{ fontSize: '36px', fontWeight: 'bold', color: '#111827', marginBottom: '10px' }}>
              Traveler <span style={{ color: '#16a34a', fontStyle: 'italic' }}>Diaries</span>
            </h2>
            <p style={{ color: '#6b7280', fontSize: '18px' }}>
              Real stories from real wanderers.
            </p>
          </div>
          
          {/* NAVIGATION BUTTONS *}
          <div style={{ display: 'flex', gap: '15px' }}>
            <button 
              onClick={() => scroll('left')}
              style={{
                width: '45px', height: '45px', borderRadius: '50%',
                border: '1px solid #d1d5db', backgroundColor: 'white',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'white'; }}
            >
              <ChevronLeft size={20} color="#374151" />
            </button>
            <button 
              onClick={() => scroll('right')}
              style={{
                width: '45px', height: '45px', borderRadius: '50%',
                border: 'none', backgroundColor: '#16a34a',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', boxShadow: '0 4px 6px rgba(22, 163, 74, 0.3)',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.05)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
            >
              <ChevronRight size={20} color="white" />
            </button>
          </div>
        </div>

        {/* --- CAROUSEL CONTAINER --- *}
        <div 
          ref={scrollRef}
          className="hide-scrollbar"
          style={{
            display: 'flex',
            gap: '30px',
            overflowX: 'auto',
            scrollSnapType: 'x mandatory',
            paddingBottom: '20px', // Space for shadow
            scrollBehavior: 'smooth'
          }}
        >
          {stories.map((story) => (
            <div key={story.id} style={{
              flex: '0 0 auto',
              width: '350px',
              scrollSnapAlign: 'start',
              backgroundColor: 'white',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
              border: '1px solid #f3f4f6',
              display: 'flex',
              flexDirection: 'column'
            }}>
              
              {/* Card Image *}
              <div style={{ height: '200px', position: 'relative' }}>
                <img 
                  src={story.image} 
                  alt={story.location} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <div style={{
                  position: 'absolute', bottom: '15px', left: '15px',
                  backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)',
                  padding: '5px 12px', borderRadius: '20px',
                  display: 'flex', alignItems: 'center', gap: '5px'
                }}>
                  <MapPin size={14} color="white" />
                  <span style={{ color: 'white', fontSize: '12px', fontWeight: '500' }}>{story.location}</span>
                </div>
              </div>

              {/* Card Content *}
              <div style={{ padding: '25px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <Quote size={24} color="#e5e7eb" style={{ marginBottom: '10px' }} />
                
                <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', marginBottom: '10px' }}>
                  {story.title}
                </h3>
                
                <p style={{ fontSize: '15px', color: '#6b7280', lineHeight: '1.6', marginBottom: '20px', flex: 1 }}>
                  "{story.snippet}"
                </p>

                {/* Divider *}
                <div style={{ width: '100%', height: '1px', backgroundColor: '#f3f4f6', marginBottom: '20px' }}></div>

                {/* Traveler Profile *}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <img 
                    src={story.avatar} 
                    alt={story.name} 
                    style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', border: '2px solid white', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                  />
                  <div>
                    <p style={{ fontSize: '14px', fontWeight: 'bold', color: '#111827', margin: 0 }}>{story.name}</p>
                    <p style={{ fontSize: '12px', color: '#9ca3af', margin: 0 }}>Verified Traveler</p>
                  </div>
                  
                  <button style={{ marginLeft: 'auto', fontSize: '13px', fontWeight: '600', color: '#16a34a', background: 'none', border: 'none', cursor: 'pointer' }}>
                    Read Story &rarr;
                  </button>
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TravelerStories;
*/

import React, { useState, useEffect } from 'react';
import { 
  BookOpen, MapPin, ArrowRight, ArrowUpRight, X, 
  Calendar, Heart, Share2, MessageCircle, Mail, Copy 
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext'; 

const API_BASE_URL = '/api';

// MOCK DATA FALLBACK (Same as StoriesPage)
const curatedStories = [
  {
    id: "curated_1",
    title: "Chasing the Monsoon in the Abode of Clouds",
    author: "Priya Sharma",
    state: "Meghalaya",
    category: "Nature",
    date: "August 2023",
    likes: 342,
    img: "https://images.unsplash.com/photo-1571536802807-30451e3955d8?auto=format&fit=crop&w=800&q=80",
    excerpt: "Walking across the living root bridges while the rain poured down was a spiritual experience. Meghalaya completely transformed my definition of green.",
    fullText: "My journey to Meghalaya started with a long, winding drive through the misty hills of the northeast. As we approached Cherrapunji, the clouds descended so low it felt like we were driving through the sky itself.\n\nThe highlight of my trip was the trek to the Double Decker Living Root Bridge. It's not just a bridge; it's a living, breathing testament to the ingenuity of the Khasi tribe. The rain was relentless, but it only added to the magic. Every waterfall we passed was roaring with life. We stayed in a small eco-lodge where the hosts served us traditional bamboo shoot pork and red rice.\n\nIf you ever feel disconnected from nature, Meghalaya is the place to find your roots again. Quite literally." 
  },
  {
    id: "curated_2",
    title: "Lost in the Colors of the Pink City",
    author: "Dev Chatterjee",
    state: "Rajasthan",
    category: "Culture",
    date: "November 2023",
    likes: 512,
    img: "https://images.unsplash.com/photo-1477587458883-47145ed94245?auto=format&fit=crop&w=800&q=80",
    excerpt: "From the majestic Amer Fort to the bustling bazaars of Johari Bazaar, Jaipur is an absolute sensory overload in the best way possible.",
    fullText: "Jaipur doesn't just welcome you it engulfs you. As a photographer, I was immediately drawn to the warm, terracotta pink hues that paint the entire old city.\n\nI spent an entire morning simply watching the light change on the intricate facade of the Hawa Mahal. Later, exploring the Amer Fort felt like stepping onto the set of an epic historical movie. What I loved most, though, wasn't the monuments, but the people. I spent hours sitting with a local block-printer, learning the rhythmic art of stamping patterns onto fabric.\n\nThe city is a vibrant paradox-deeply rooted in royal history, yet buzzing with chaotic modern life. Do not leave without trying the Pyaz Kachori!"
  },
  {
    id: "curated_3",
    title: "Finding Silence in the Backwaters",
    author: "Ananya Desai",
    state: "Kerala",
    category: "Relaxation",
    date: "January 2024",
    likes: 428,
    img: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?auto=format&fit=crop&w=800&q=80",
    excerpt: "Two days on a houseboat in Alleppey taught me the true meaning of slow living. Just water, palm trees, and absolute peace.",
    fullText: "I booked a houseboat in Alleppey expecting a standard tourist experience, but what I got was profound stillness.\n\nDrifting through the narrow, emerald-green canals, the only sounds were the gentle lapping of water against the wooden hull and the occasional call of a kingfisher. Our boat crew prepared the most incredible fresh Karimeen (pearl spot fish) wrapped in banana leaves, cooked right there on the boat.\n\nWe passed small villages where life revolves entirely around the water-children taking small boats to school, women washing clothes on the steps. It was a humbling, beautiful glimpse into a life moving at a completely different, much healthier pace."
  },
  {
    id: "curated_4",
    title: "A Solo Trekker's Guide to the Himalayas",
    author: "Vikram Singh",
    state: "Himachal Pradesh",
    category: "Adventure",
    date: "May 2023",
    likes: 675,
    img: "https://himtrek.co.in/wp-content/uploads/2023/09/NIP0120.jpg",
    excerpt: "The trek to Kheerganga was exhausting, but soaking in the natural hot springs surrounded by snow-capped peaks made every step worth it.",
    fullText: "Parvati Valley is legendary among backpackers, and for good reason. I set off on the Kheerganga trek early in the morning. The trail weaves through dense pine forests, over roaring rivers, and past tiny villages clinging to the mountainside.\n\nAbout halfway up, my legs were burning, but the camaraderie on the trail kept me going. Fellow trekkers share water, stories, and encouragement. When I finally reached the top, the reward was unparalleled: a natural, steaming hot spring right at the edge of the mountain.\n\nSitting in that hot water while snowflakes gently drifted down around me is a core memory I will cherish forever. Himachal changes you."
  }
];

const formatImageUrl = (backendPath) => {
  if (!backendPath) return "https://images.unsplash.com/photo-1506461883276-594a12b11cf3?auto=format&fit=crop&w=800&q=80";
  if (backendPath.startsWith('http://localhost') || backendPath.startsWith('http://127.0.0.1')) {
    const url = new URL(backendPath);
    return url.pathname;
  }
  if (backendPath.startsWith('http')) return backendPath;
  const cleanPath = backendPath.replace('backend/', '');
  return cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
};

const TravellerStories = () => {
  const navigate = useNavigate();
  const { isDark } = useTheme(); 
  
  const [allStories, setAllStories] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  
  // Modal States
  const [selectedStory, setSelectedStory] = useState(null);
  const [likedStories, setLikedStories] = useState({});
  const [shareMenuOpen, setShareMenuOpen] = useState(null);

  useEffect(() => {
    const fetchTravelStories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/get_travel_stories`);
        if (response.ok) {
          const data = await response.json();
          const dbStories = data.travel_stories.map(story => ({
            id: story.id,
            title: story.title,
            author: story.user_id.split('@')[0],
            state: story.location,
            category: story.expedition_type,
            date: story.date,
            likes: story.likes || Math.floor(Math.random() * 50) + 10,
            img: story.images && story.images.length > 0 ? formatImageUrl(story.images[0]) : formatImageUrl(null),
            excerpt: story.description.substring(0, 120) + "...",
            fullText: story.description
          }));
          setAllStories([...dbStories, ...curatedStories]);
        } else {
          setAllStories(curatedStories);
        }
      } catch (error) {
        console.error("Failed to fetch stories, using fallback data.");
        setAllStories(curatedStories);
      }
    };

    fetchTravelStories();
  }, []);

  useEffect(() => {
    if (allStories.length <= 3 || isHovered || selectedStory) return;
    
    const interval = setInterval(() => {
      setStartIndex((prevIndex) => (prevIndex + 1) % allStories.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [allStories.length, isHovered, selectedStory]);

  const displayedStories = [];
  if (allStories.length > 0) {
    for (let i = 0; i < Math.min(3, allStories.length); i++) {
      displayedStories.push(allStories[(startIndex + i) % allStories.length]);
    }
  }

  const handleLike = (e, storyId) => {
    e.stopPropagation();
    setLikedStories(prev => ({ ...prev, [storyId]: !prev[storyId] }));
  };

  const handleShareClick = (e, story) => {
    e.stopPropagation();
    const shareData = { title: story.title, text: `Check out this diary: "${story.title}"`, url: window.location.href };
    if (navigator.share) {
      try { navigator.share(shareData); } catch (err) {}
    } else {
      setShareMenuOpen(shareMenuOpen === story.id ? null : story.id);
    }
  };

  const executeFallbackShare = (e, type, story) => {
    e.stopPropagation();
    const shareText = `Check out this travel diary: "${story.title}"`;
    const shareUrl = window.location.href;
    if (type === 'whatsapp') window.open(`https://wa.me/?text=${encodeURIComponent(shareText + " " + shareUrl)}`, '_blank');
    else if (type === 'email') window.location.href = `mailto:?subject=Odessey Travel Diary&body=${encodeURIComponent(shareText + '\n\n' + shareUrl)}`;
    else if (type === 'copy') { navigator.clipboard.writeText(`${shareText} ${shareUrl}`); setShareMenuOpen(null); }
  };

  return (
    <section id="traveler-diaries" style={{ padding: '80px 20px', backgroundColor: isDark ? '#111827' : '#f9fafb', fontFamily: 'system-ui, -apple-system, sans-serif', transition: 'background-color 0.3s' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        
        {/* HEADER SECTION */}
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: '20px', marginBottom: '50px' }}>
          <div style={{ maxWidth: '600px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: isDark ? '#4ade80' : '#16a34a', fontWeight: 'bold', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>
              <BookOpen size={18} /> Travel Diaries
            </div>
            <h2 style={{ fontSize: '36px', fontWeight: '800', color: isDark ? '#f9fafb' : '#111827', lineHeight: '1.2' }}>
              Real Stories from Real Travellers
            </h2>
          </div>
          
          {/* VIEW ALL BUTTON (Desktop) */}
          <button 
            className="desktop-view-btn"
            onClick={() => navigate('/stories')}
            style={{ 
              display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', borderRadius: '50px', 
              backgroundColor: isDark ? '#1f2937' : 'white', 
              border: isDark ? '1px solid #374151' : '1px solid #d1d5db', 
              color: isDark ? '#f9fafb' : '#374151', fontSize: '15px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' 
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#16a34a'; e.currentTarget.style.color = '#16a34a'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = isDark ? '#374151' : '#d1d5db'; e.currentTarget.style.color = isDark ? '#f9fafb' : '#374151'; }}
          >
            View All Diaries <ArrowRight size={18} />
          </button>
        </div>

        {/* STORIES GRID / MOBILE CAROUSEL */}
        <div 
          className="stories-grid-container"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {displayedStories.map((story) => (
            <div 
              key={story.id} 
              onClick={() => setSelectedStory(story)}
              className="story-card"
              style={{ 
                backgroundColor: isDark ? '#1f2937' : 'white', 
                borderRadius: '24px', overflow: 'hidden', 
                border: isDark ? '1px solid #374151' : '1px solid #e5e7eb', 
                boxShadow: isDark ? '0 10px 25px rgba(0,0,0,0.4)' : '0 10px 25px rgba(0,0,0,0.03)', 
                transition: 'transform 0.3s ease, box-shadow 0.3s ease', cursor: 'pointer', display: 'flex', flexDirection: 'column' 
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = isDark ? '0 20px 40px rgba(0,0,0,0.6)' : '0 20px 40px rgba(0,0,0,0.08)'; e.currentTarget.querySelector('.read-more-icon').style.transform = 'translate(4px, -4px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = isDark ? '0 10px 25px rgba(0,0,0,0.4)' : '0 10px 25px rgba(0,0,0,0.03)'; e.currentTarget.querySelector('.read-more-icon').style.transform = 'translate(0, 0)'; }}
            >
              {/* Image & Tags */}
              <div style={{ height: '220px', overflow: 'hidden', position: 'relative' }}>
                <img src={story.img} alt={story.title} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' }} onMouseEnter={(e)=>e.currentTarget.style.transform='scale(1.05)'} onMouseLeave={(e)=>e.currentTarget.style.transform='scale(1)'}/>
                <div style={{ position: 'absolute', top: '15px', left: '15px', display: 'flex', gap: '8px' }}>
                  <span style={{ backgroundColor: isDark ? 'rgba(31, 41, 55, 0.85)' : 'rgba(255,255,255,0.9)', backdropFilter: 'blur(4px)', color: isDark ? '#f9fafb' : '#1f2937', padding: '6px 12px', borderRadius: '50px', fontSize: '12px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <MapPin size={12} color="#16a34a" /> {story.state}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div style={{ padding: '25px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                <div style={{ fontSize: '13px', color: isDark ? '#4ade80' : '#16a34a', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>
                  By {story.author}
                </div>
                <h3 style={{ fontSize: '20px', fontWeight: '800', color: isDark ? '#f9fafb' : '#111827', marginBottom: '12px', lineHeight: '1.4' }}>
                  {story.title}
                </h3>
                <p style={{ fontSize: '15px', color: isDark ? '#d1d5db' : '#4b5563', lineHeight: '1.6', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', flex: 1, marginBottom: '20px' }}>
                  {story.excerpt}
                </p>
                
                <div style={{ borderTop: isDark ? '1px solid #374151' : '1px solid #f3f4f6', paddingTop: '15px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', color: isDark ? '#f9fafb' : '#1f2937', fontWeight: '700', fontSize: '14px', marginTop: 'auto' }}>
                  Read Full Story
                  <div className="read-more-icon" style={{ transition: 'transform 0.2s', color: '#16a34a' }}>
                    <ArrowUpRight size={20} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* MOBILE FALLBACK BUTTON */}
        <div className="mobile-view-btn-container" style={{ textAlign: 'center', marginTop: '40px' }}>
           <button 
             onClick={() => navigate('/stories')}
             style={{ padding: '16px 32px', borderRadius: '50px', backgroundColor: '#16a34a', color: 'white', fontSize: '16px', fontWeight: 'bold', border: 'none', cursor: 'pointer', transition: 'all 0.3s', display: 'inline-flex', alignItems: 'center', gap: '10px' }}
             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#15803d'}
             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#16a34a'}
           >
             Explore All Diaries <ArrowRight size={20} />
           </button>
        </div>

      </div>

      {/* MODAL OVERLAY */}
      {selectedStory && (
        <div onClick={() => { setSelectedStory(null); setShareMenuOpen(null); }} style={{ position: 'fixed', inset: 0, zIndex: 100, backgroundColor: 'rgba(17, 24, 39, 0.8)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div onClick={(e) => { e.stopPropagation(); setShareMenuOpen(null); }} style={{ backgroundColor: isDark ? '#1f2937' : 'white', width: '100%', maxWidth: '850px', maxHeight: '90vh', borderRadius: '24px', overflow: 'hidden', display: 'flex', flexDirection: 'column', position: 'relative', boxShadow: '0 25px 50px rgba(0,0,0,0.5)', animation: 'slideUp 0.3s ease-out forwards' }}>
            <button onClick={() => setSelectedStory(null)} style={{ position: 'absolute', top: '20px', right: '20px', background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)', border: 'none', borderRadius: '50%', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'white', zIndex: 10, transition: 'background 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.8)'} onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(0,0,0,0.5)'}>
              <X size={24} />
            </button>
           
            <div style={{ height: '350px', flexShrink: 0, position: 'relative' }}>
              <img src={selectedStory.img} alt={selectedStory.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(17, 24, 39, 0.9), transparent)' }} />
              <div style={{ position: 'absolute', bottom: '30px', left: '40px', right: '40px' }}>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                  <span style={{ backgroundColor: '#16a34a', color: 'white', padding: '6px 14px', borderRadius: '50px', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <BookOpen size={14} /> Travel Diary
                  </span>
                  <span style={{ backgroundColor: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(4px)', color: 'white', padding: '6px 14px', borderRadius: '50px', fontSize: '12px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <MapPin size={14} /> {selectedStory.state}
                  </span>
                </div>
                <h2 style={{ color: 'white', fontSize: '36px', fontWeight: '800', lineHeight: '1.2' }}>{selectedStory.title}</h2>
              </div>
            </div>
           
            <div style={{ padding: '40px', overflowY: 'auto', backgroundColor: isDark ? '#111827' : '#f9fafb' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '35px', borderBottom: isDark ? '1px solid #374151' : '1px solid #e5e7eb', paddingBottom: '25px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{ width: '56px', height: '56px', borderRadius: '50%', backgroundColor: isDark ? '#082f49' : '#e0f2fe', color: isDark ? '#38bdf8' : '#0284c7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '22px' }}>
                    {selectedStory.author.charAt(0)}
                  </div>
                  <div>
                    <h4 style={{ fontWeight: 'bold', color: isDark ? '#f9fafb' : '#111827', fontSize: '18px' }}>{selectedStory.author}</h4>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: isDark ? '#9ca3af' : '#6b7280', fontSize: '14px', marginTop: '4px' }}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><Calendar size={14} /> {selectedStory.date}</span>
                    </div>
                  </div>
                </div>
               
                <div style={{ display: 'flex', gap: '10px', position: 'relative' }}>
                  <button onClick={(e) => handleLike(e, selectedStory.id)} style={{ width: '45px', height: '40px', borderRadius: '50%', border: isDark ? '1px solid #374151' : '1px solid #e5e7eb', backgroundColor: isDark ? '#1f2937' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', color: likedStories[selectedStory.id] ? '#ef4444' : (isDark ? '#9ca3af' : '#6b7280'), cursor: 'pointer', transition: 'all 0.2s' }}>
                    <Heart size={18} fill={likedStories[selectedStory.id] ? '#ef4444' : 'none'} />
                  </button>
                  <button onClick={(e) => handleShareClick(e, selectedStory)} style={{ width: '40px', height: '40px', borderRadius: '50%', border: isDark ? '1px solid #374151' : '1px solid #e5e7eb', backgroundColor: isDark ? '#1f2937' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', color: shareMenuOpen === selectedStory.id ? '#0284c7' : (isDark ? '#9ca3af' : '#6b7280'), cursor: 'pointer', transition: 'all 0.2s' }}>
                    <Share2 size={18} />
                  </button>
                 
                  {shareMenuOpen === selectedStory.id && (
                    <div style={{ position: 'absolute', top: '100%', right: '0', marginTop: '10px', backgroundColor: isDark ? '#1f2937' : 'white', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0,0,0,0.3)', border: isDark ? '1px solid #374151' : '1px solid #e5e7eb', overflow: 'hidden', zIndex: 50, width: '160px', animation: 'slideUp 0.2s ease-out' }}>
                      <button onClick={(e) => executeFallbackShare(e, 'whatsapp', selectedStory)} style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '12px 16px', border: 'none', borderBottom: isDark ? '1px solid #374151' : '1px solid #f3f4f6', background: isDark ? '#1f2937' : 'white', cursor: 'pointer', color: isDark ? '#f9fafb' : '#374151', fontSize: '14px', fontWeight: '500' }}>
                        <MessageCircle size={16} color="#25D366" /> WhatsApp
                      </button>
                      <button onClick={(e) => executeFallbackShare(e, 'email', selectedStory)} style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '12px 16px', border: 'none', borderBottom: isDark ? '1px solid #374151' : '1px solid #f3f4f6', background: isDark ? '#1f2937' : 'white', cursor: 'pointer', color: isDark ? '#f9fafb' : '#374151', fontSize: '14px', fontWeight: '500' }}>
                        <Mail size={16} color="#0284c7" /> Email
                      </button>
                      <button onClick={(e) => executeFallbackShare(e, 'copy', selectedStory)} style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', padding: '12px 16px', border: 'none', background: isDark ? '#1f2937' : 'white', cursor: 'pointer', color: isDark ? '#f9fafb' : '#374151', fontSize: '14px', fontWeight: '500' }}>
                        <Copy size={16} color="#6B7280" /> Copy Link
                      </button>
                    </div>
                  )}
                </div>
              </div>
             
              <div style={{ fontSize: '18px', lineHeight: '1.9', color: isDark ? '#d1d5db' : '#374151', whiteSpace: 'pre-line' }}>
                <p style={{ fontSize: '22px', fontStyle: 'italic', color: isDark ? '#f9fafb' : '#111827', marginBottom: '30px', borderLeft: '4px solid #16a34a', paddingLeft: '20px' }}>
                  "{selectedStory.excerpt}"
                </p>
                {selectedStory.fullText}
              </div>
             
              <div style={{ marginTop: '50px', backgroundColor: isDark ? '#064e3b' : '#f0fdf4', padding: '30px', borderRadius: '16px', textAlign: 'center', border: isDark ? '1px solid #065f46' : '1px solid #bbf7d0' }}>
                <h4 style={{ fontSize: '20px', fontWeight: 'bold', color: isDark ? '#a7f3d0' : '#15803d', marginBottom: '10px' }}>Inspired by this story?</h4>
                <p style={{ color: isDark ? '#d1fae5' : '#166534', marginBottom: '20px' }}>Explore top cities, spots, and hidden gems in {selectedStory.state}.</p>
                <button onClick={() => navigate(`/state/${encodeURIComponent(selectedStory.state)}`)} style={{ padding: '14px 30px', borderRadius: '50px', backgroundColor: '#16a34a', color: 'white', fontSize: '15px', fontWeight: 'bold', border: 'none', cursor: 'pointer', transition: 'background 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#15803d'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#16a34a'}>
                  Explore {selectedStory.state}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 👇 RESPONSIVE CAROUSEL CSS LOGIC 👇 */}
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.98); }
          to { opacity: 1; transform: scale(1); }
        }

        /* DESKTOP GRID LAYOUT */
        .stories-grid-container {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 30px;
        }

        /* MOBILE CAROUSEL LAYOUT */
        @media (max-width: 768px) {
          .desktop-view-btn {
            display: none !important;
          }
          /* Turn grid into a smooth horizontal swipeable carousel on mobile */
          .stories-grid-container {
            display: flex !important;
            overflow-x: auto !important;
            scroll-snap-type: x mandatory !important;
            gap: 20px !important;
            padding-bottom: 15px !important;
            -webkit-overflow-scrolling: touch;
          }
          .stories-grid-container::-webkit-scrollbar {
            display: none;
          }
          .story-card {
            flex: 0 0 85% !important; /* Cards take up 85% of screen width so next card peeks through */
            scroll-snap-align: center !important;
          }
        }
        @media (min-width: 769px) {
          .mobile-view-btn-container {
            display: none !important;
          }
        }
      `}</style>
    </section>
  );
};

export default TravellerStories;